"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var arrayMerge = function arrayMerge() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var arg1 = args.shift();
  if (!(0, _reshowConstant.IS_ARRAY)(arg1)) {
    arg1 = [arg1];
  }
  args.forEach(function (a) {
    if (null == a) {
      return;
    }
    if ((0, _reshowConstant.IS_ARRAY)(a)) {
      arg1 = arg1.concat(a);
    } else {
      arg1.push(a);
    }
  });
  return arg1;
};
var _default = arrayMerge;
exports["default"] = _default;
module.exports = exports.default;